import crypto from "crypto"

export const webcrypto = crypto.webcrypto
